import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
})

export class TookanFetchAPI {

    //Function to get tookan fare order 
    static async getTookanFareOrder(token, data){
        const res = await server(`/fare/tookan`, {
            method: "post",
            headers: token ? { 'x-access-token': token } : undefined,
            data: data,
        });
        return res;
    }

    //Function to register the tookan order
    static async registerTookanOrder(token, data){
        const res = await server(`/tookan`, {
            method: "post",
            headers: token ? { 'x-access-token': token } : undefined,
            data: data,
        });
        return res;
    }
    //Function to get tookan order details
    static async getTookanOrderDetails(token, business_id, rider_order_id){
        const res = await server(`/tookan?business_id=${business_id}&rider_order_id=${rider_order_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res;
    }
}